import './license';
import 'bootstrap/dist/css/bootstrap.css';
import '@mescius/wijmo.styles/wijmo.css';
import './index.css';

import { createApp } from 'vue'
import App from './App.vue'
import { registerChart } from '@mescius/wijmo.vue2.chart';
import { registerChartAnalytics } from '@mescius/wijmo.vue2.chart.analytics';
import { registerChartAnimation } from '@mescius/wijmo.vue2.chart.animation';
import { registerChartAnnotation } from '@mescius/wijmo.vue2.chart.annotation';
import { registerChartFinance } from '@mescius/wijmo.vue2.chart.finance';
import { registerChartHierarchical } from '@mescius/wijmo.vue2.chart.hierarchical';
import { registerChartInteraction } from '@mescius/wijmo.vue2.chart.interaction';
import { registerChartRadar } from '@mescius/wijmo.vue2.chart.radar';
import { registerCore } from '@mescius/wijmo.vue2.core';
import { registerGauge } from '@mescius/wijmo.vue2.gauge';
import { registerGrid } from '@mescius/wijmo.vue2.grid';
import { registerGridDetail } from '@mescius/wijmo.vue2.grid.detail';
import { registerGridFilter } from '@mescius/wijmo.vue2.grid.filter';
import { registerGridGrouppanel } from '@mescius/wijmo.vue2.grid.grouppanel';
import { registerGridMultirow } from '@mescius/wijmo.vue2.grid.multirow';
import { registerGridSearch } from '@mescius/wijmo.vue2.grid.search';
import { registerGridSheet } from '@mescius/wijmo.vue2.grid.sheet';
import { registerGridTransposed } from '@mescius/wijmo.vue2.grid.transposed';
import { registerGridTransposedMultirow } from '@mescius/wijmo.vue2.grid.transposedmultirow';
import { registerInput } from '@mescius/wijmo.vue2.input';
import { registerNav } from '@mescius/wijmo.vue2.nav';
import { registerOlap } from '@mescius/wijmo.vue2.olap';
import { registerViewer } from '@mescius/wijmo.vue2.viewer';

const app = createApp(App);
registerChart(app);
registerChartAnalytics(app);
registerChartAnimation(app);
registerChartAnnotation(app);
registerChartFinance(app);
registerChartHierarchical(app);
registerChartInteraction(app);
registerChartRadar(app);
registerCore(app);
registerGauge(app);
registerGrid(app);
registerGridDetail(app);
registerGridFilter(app);
registerGridGrouppanel(app);
registerGridMultirow(app);
registerGridSearch(app);
registerGridSheet(app);
registerGridTransposed(app);
registerGridTransposedMultirow(app);
registerInput(app);
registerNav(app);
registerOlap(app);
registerViewer(app);
app.mount('#app');
